// GENERATED by scripts/gen-icons.mjs — do not edit.
// Run `npm run gen:icons` after bumping lucide-react.

import {
    SearchCode,
    SearchSlash,
    SearchX,
    Section,
    Send,
    SendHorizontal,
    SendToBack,
    SeparatorHorizontal,
    SeparatorVertical,
    Server,
    ServerCog,
    ServerCrash,
    ServerOff,
    ServerPlus,
    Settings,
    Settings2,
    Shapes,
    Share,
    Share2,
    Sheet,
    Shell,
    ShelvingUnit,
    Shield,
    ShieldAlert,
    ShieldBan,
    ShieldCheck,
    ShieldCog,
    ShieldCogCorner,
    ShieldEllipsis,
    ShieldHalf,
    ShieldKeyhole,
    ShieldLock,
    ShieldMinus,
    ShieldOff,
    ShieldPlus,
    ShieldQuestionMark,
    ShieldUser,
    ShieldX,
    Ship,
    ShipCargo,
} from "lucide-react";
import type { LucideIcon } from "lucide-react";

/** The 40 lucide icons from "search-code" through "ship-cargo", inclusive. */
const shard: Record<string, LucideIcon> = {
    "search-code": SearchCode,
    "search-slash": SearchSlash,
    "search-x": SearchX,
    section: Section,
    send: Send,
    "send-horizontal": SendHorizontal,
    "send-to-back": SendToBack,
    "separator-horizontal": SeparatorHorizontal,
    "separator-vertical": SeparatorVertical,
    server: Server,
    "server-cog": ServerCog,
    "server-crash": ServerCrash,
    "server-off": ServerOff,
    "server-plus": ServerPlus,
    settings: Settings,
    "settings-2": Settings2,
    shapes: Shapes,
    share: Share,
    "share-2": Share2,
    sheet: Sheet,
    shell: Shell,
    "shelving-unit": ShelvingUnit,
    shield: Shield,
    "shield-alert": ShieldAlert,
    "shield-ban": ShieldBan,
    "shield-check": ShieldCheck,
    "shield-cog": ShieldCog,
    "shield-cog-corner": ShieldCogCorner,
    "shield-ellipsis": ShieldEllipsis,
    "shield-half": ShieldHalf,
    "shield-keyhole": ShieldKeyhole,
    "shield-lock": ShieldLock,
    "shield-minus": ShieldMinus,
    "shield-off": ShieldOff,
    "shield-plus": ShieldPlus,
    "shield-question-mark": ShieldQuestionMark,
    "shield-user": ShieldUser,
    "shield-x": ShieldX,
    ship: Ship,
    "ship-cargo": ShipCargo,
};

export default shard;
